import { render } from "./Footer.vue?vue&type=template&id=51ec5404"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=51ec5404&lang=scss"
script.render = render

export default script